import { Phone } from './PhoneImage';

export default Phone;
